import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const companyDutyLocaleModule: LocaleModule = {
  name: "companyDuty",
  messages: { en: en, it: it },
};
